import React from "react"
import { useTranslation } from "react-i18next"

import { EnvelopeDocumentDrawer } from "../../components/EnvelopeDocumentDrawer.tsx"
import type { TrackedEnvelope } from "../../types/tracking.types.ts"

interface Props {
  envelope: TrackedEnvelope
  onClose: () => void
}

/** The tracked row's document, with its signing progress as the subtitle. */
export function SignedDocumentDrawer({ envelope, onClose }: Props) {
  const { t } = useTranslation()
  const completed = envelope.status === "completed"
  const signers = envelope.recipients.filter(
    (recipient) => recipient.role === "signer"
  )
  const signed = signers.filter(
    (recipient) => recipient.status === "signed"
  ).length

  return (
    <EnvelopeDocumentDrawer
      envelopeId={envelope.id}
      documentName={envelope.subject.name}
      withCertificate={completed}
      subtitle={
        completed
          ? t("esign.tracking.viewer.completed")
          : t("esign.tracking.viewer.signedSoFar", {
              signed,
              total: signers.length
            })
      }
      onClose={onClose}
    />
  )
}
